import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type League = "MLB" | "NFL";

/** Identifies the league. League colors are identity only — never state. */
export function LeagueBadge({
	league,
	className,
}: {
	league: League;
	className?: string;
}) {
	return (
		<Badge
			className={cn(
				"px-1.5 py-1 font-display text-[0.8125rem] leading-none font-bold tracking-wider",
				className,
			)}
			variant={league === "NFL" ? "nfl" : "mlb"}
		>
			{league}
		</Badge>
	);
}
